export type RewardMilestoneCandidate = {
  rewardId: string;
  minimumVisits?: number | null;
  cashToUnlock: number;
  unlockProgressPercent: number;
};

export type NextRewardMilestone = {
  minimumVisits: number;
  rewardsCount: number;
  cashToUnlock: number;
  unlockProgressPercent: number;
};

export const getNextRewardMilestone = (
  futureRewards: readonly RewardMilestoneCandidate[],
): NextRewardMilestone | undefined => {
  if (futureRewards.length === 0) {
    return undefined;
  }

  const visitRewards = futureRewards.map((reward) => {
    if (reward.minimumVisits == null) {
      throw new Error(`Future visit reward ${reward.rewardId} is missing minimumVisits`);
    }

    return {
      ...reward,
      minimumVisits: reward.minimumVisits,
    };
  });

  const minimumVisits = Math.min(...visitRewards.map((reward) => reward.minimumVisits));
  const rewardsAtMilestone = visitRewards.filter(
    (reward) => reward.minimumVisits === minimumVisits,
  );

  const representativeReward = rewardsAtMilestone.reduce((bestReward, reward) => {
    if (reward.unlockProgressPercent !== bestReward.unlockProgressPercent) {
      return reward.unlockProgressPercent > bestReward.unlockProgressPercent ? reward : bestReward;
    }

    return reward.rewardId.localeCompare(bestReward.rewardId) < 0 ? reward : bestReward;
  });

  return {
    minimumVisits,
    rewardsCount: rewardsAtMilestone.length,
    cashToUnlock: representativeReward.cashToUnlock,
    unlockProgressPercent: representativeReward.unlockProgressPercent,
  };
};
